import {
  CART_LAYOUTS_REQUESTED,
  CART_LAYOUTS_SUCCESS,
  CART_LAYOUTS_FAILURE,
  CART_LAYOUT_FIND_REQUESTED,
  CART_LAYOUT_FIND_SUCCESS,
  CART_LAYOUT_FIND_FAILURE,
  CART_LAYOUT_CREATE_REQUESTED,
  CART_LAYOUT_CREATE_SUCCESS,
  CART_LAYOUT_CREATE_FAILURE,
  CART_LAYOUT_UPDATE_REQUESTED,
  CART_LAYOUT_UPDATE_SUCCESS,
  CART_LAYOUT_UPDATE_FAILURE,
  CART_LAYOUT_DELETE_REQUESTED,
  CART_LAYOUT_DELETE_SUCCESS,
  CART_LAYOUT_DELETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  cartLayouts: [],
  newCartLayout: null,
  activeCartLayout: null,
  lastPage: false,
  continuationToken: null,
  isFetching: false,
  isCreating: false,
  isUpdating: false,
  status: 'waiting',
  errors: null
};

const cartLayouts = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case CART_LAYOUTS_REQUESTED:
      return Object.assign({}, state, {
        cartLayouts: [],
        newCartLayout: null,
        isFetching: true,
        lastPage: false,
        continuationToken: null,
        status: 'requested',
        errors: null
      });

    case CART_LAYOUTS_SUCCESS:
      return Object.assign({}, state, {
        cartLayouts: action.payload.cart_layouts || [],
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        isFetching: false,
        status: 'success',
        errors: null
      });

    case CART_LAYOUTS_FAILURE:
      return Object.assign({}, state, {
        cartLayouts: [],
        isFetching: false,
        status: 'error',
        errors: action.error
      });


    case CART_LAYOUT_FIND_REQUESTED:
      newState.isFetching = true;
      newState.status = 'requesting';
      newState.activeCartLayout = null;
      return newState;

    case CART_LAYOUT_FIND_SUCCESS:
      newState.isFetching = false;
      newState.status = 'success';
      newState.activeCartLayout = action.payload;

      return newState;

    case CART_LAYOUT_FIND_FAILURE:
      newState.isFetching = false;
      newState.status = 'waiting';
      return newState;


    case CART_LAYOUT_CREATE_REQUESTED:
      newState.isCreating = true;
      newState.newCartLayout = null;
      return newState;


    case CART_LAYOUT_CREATE_SUCCESS:
      newState.isCreating = false;
      newState.newCartLayout = action.payload;
      return newState;


    case CART_LAYOUT_CREATE_FAILURE:
      newState.isCreating = false;
      return newState;


    case CART_LAYOUT_UPDATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      newState.newCartLayout = null;
      return newState;

    case CART_LAYOUT_UPDATE_SUCCESS:
      newState.isUpdating = false;
      newState.newCartLayout = action.payload;
      return newState;

    case CART_LAYOUT_UPDATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Could not update cart layout';
      return newState;


    case CART_LAYOUT_DELETE_REQUESTED:
      newState.isUpdating = true;
      newState.cartLayouts = newState.cartLayouts.filter(cartLayout => cartLayout.id.split("#")[1] !== action.cartLayoutId);
      newState.errors = null;
      return newState;

    case CART_LAYOUT_DELETE_SUCCESS:
      newState.isUpdating = false;
      return newState;

    case CART_LAYOUT_DELETE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to disable cart layout';
      return newState;

    default:
      return state;
  }
}

export default cartLayouts;
